import { createContext, type FC, type PropsWithChildren, useContext, useMemo } from "react";

export type AnalyticValues = Record<string, string | number | boolean | null | undefined>;

const AnalyticValuesContext = createContext<AnalyticValues>({});

export const AnalyticValuesProvider: FC<PropsWithChildren<{ props: AnalyticValues }>> = ({ children, props }) => {
	const parentAnalyticValues = useContext(AnalyticValuesContext);
	const mergedValues = useMemo(() => ({ ...props, ...parentAnalyticValues }), [props, parentAnalyticValues]);

	return <AnalyticValuesContext.Provider value={mergedValues}>{children}</AnalyticValuesContext.Provider>;
};

export function useAnalyticValues(): AnalyticValues {
	return useContext(AnalyticValuesContext);
}
